import * as Yup from 'yup';

const yesNo = () => Yup.string().oneOf(['yes', 'no'], 'Required').required('Required');

export const ContractingFormSchema = Yup.object().shape({
  firstName: Yup.string().trim().required('Required'),
  lastName: Yup.string().trim().required('Required'),
  email: Yup.string().trim().email('Invalid email').required('Required'),
  salesTaxCollected: yesNo(),
  registrationFeesCollected: yesNo(),
  titleTransferCompleted: yesNo(),
  registrationTransferCompleted: yesNo(),
  dealNotes: Yup.string().trim().optional(),
  disclosureAgreementName: Yup.string().when(
    ['titleTransferCompleted', 'registrationTransferCompleted'],
    {
      is: (titleTransferCompleted: string, registrationTransferCompleted: string) =>
        titleTransferCompleted === 'no' || registrationTransferCompleted === 'no',
      then: (s) =>
        s
          .trim()
          .required('Please type your full name to agree')
          // Salesforce requires the typed signature to match the contact name on the form.
          .test(
            'matches-contact-name',
            'This must match the First and Last Name entered above',
            (value, ctx) => {
              const normalize = (v: string) => (v || '').trim().replace(/\s+/g, ' ').toLowerCase();
              const expected = normalize(`${ctx.parent.firstName ?? ''} ${ctx.parent.lastName ?? ''}`);
              return expected !== '' && normalize(value ?? '') === expected;
            }
          ),
      otherwise: (s) => s.optional(),
    }
  ),
});

export const contractingFormInitialValues = {
  firstName: '',
  lastName: '',
  email: '',
  salesTaxCollected: '',
  registrationFeesCollected: '',
  titleTransferCompleted: '',
  registrationTransferCompleted: '',
  dealNotes: '',
  disclosureAgreementName: '',
};
